import { EnvironmentResponse } from './environment.models';

export interface EnvironmentState extends EnvironmentResponse {
	/**
	 * If the environment has loaded.
	 */
	loaded: boolean;
}

export const initialState: EnvironmentState = {
	loaded: false,
	environmentName: '',
	domain: '',
	gatewayUrl: '',
	isProduction: false,
	subDomainBase: '',
	subDomainPrefix: '',
	subDomainSuffix: '',
};
